// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".oldEquipmentPage .container-fluid.mcc-container{margin-top:0!important}", "",{"version":3,"sources":["webpack://./resources/js/v2/pages/old-equipment/old-equipment.scss"],"names":[],"mappings":"AAAA,iDACE,sBACF","sourcesContent":[".oldEquipmentPage .container-fluid.mcc-container {\n  margin-top: 0 !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
